import { render } from "./AudioListComp.vue?vue&type=template&id=a8e08932&scoped=true"
import script from "./AudioListComp.vue?vue&type=script&lang=js"
export * from "./AudioListComp.vue?vue&type=script&lang=js"

import "./AudioListComp.vue?vue&type=style&index=0&id=a8e08932&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e08932"]])

export default __exports__